import { Component, Input, OnInit } from '@angular/core';
import { ListService } from '@app/common/services/list.service';
import { transformListToFilter } from '@app/common/utils/list.utils';
import { Restangular } from 'ngx-restangular';
import { ListModel } from "@app/common/models/list.model";
import { CallbackModel } from '@app/common/models/callback.model';
import { Callbacks } from '@app/ps/enums/callbacks.enum';
import { FinalSolutionTypesEnum } from "@app/ps/enums/final-solution-types.enum";
import { PERMANENT_WITH_PURCHASE } from '@app/ps/enums/occupation-type.enum';

@Component({
  templateUrl: './occupations-change-final-solution-type-confirm.component.html',
  styleUrls: ['./occupations-change-final-solution-type-confirm.component.scss'],
})
export class OccupationsChangeFinalSolutionTypeConfirmComponent implements OnInit {
  @Input() data: any;
  callbacks: CallbackModel;
  private list: ListModel<any>;
  public readonly FinalSolutionTypesEnum = FinalSolutionTypesEnum;

  constructor(
    private listService: ListService,
    private restangular: Restangular,
  ) {
    this.proceed = this.proceed.bind(this);
  }

  ngOnInit() {
    this.list = this.listService.createList('occupations', {
      limit: null,
      filters: Object.assign(
      this.listService.toFilterRequestMessage(transformListToFilter({ filters: this.data.selectEntities.filters })).filters,
      {
        entityId: {
          values: this.data.selectEntities.checkedItems
            .map((entity: any) => entity.id),
          negation: this.data.selectEntities.inverseSelection,
        }
      }
    )});

    this.listService.fetchResult(this.list);
  }

  async proceed() {
    let updatedCount = 0;
    const totalCount = this.list.list.length;
    const failureMap: { [reason: string]: number } = {};
    for (const item of this.list.list) {
      item.finalSolutionType = this.data.details.occupationSolutionType;
      item.finalSolutionReason = this.data.details.finalSolutionReason;
      item.editMode = 'final-solution-type';
      const isOtherChange = this.data.details.occupationSolutionType && this.data.details.occupationSolutionType.key === FinalSolutionTypesEnum.OTHER_CHANGE;
      if (isOtherChange) {
        const otherChange = Object.assign({}, this.data.details.finalSolutionOtherChange || {});
        if (!otherChange.changeGeometry) { delete otherChange.changeGeometry; }
        if (!otherChange.changeWholeParcel) { delete otherChange.changeWholeParcel; }
        if (!otherChange.changeOccupationType) {
          delete otherChange.changeOccupationType;
          delete otherChange.newOccupationType;
        } else if (otherChange.newOccupationType) {
          const t = otherChange.newOccupationType;
          otherChange.newOccupationType = { id: t.id, number: t.number, name: t.name };
        }
        if (!otherChange.changeConstructionObjects) {
          delete otherChange.changeConstructionObjects;
          delete otherChange.newConstructionObjects;
        } else if (otherChange.newConstructionObjects && otherChange.newConstructionObjects.length) {
          otherChange.newConstructionObjects = otherChange.newConstructionObjects.map(co => ({ id: co.id }));
        }
        if (!otherChange.changeOccupationNumber) {
          delete otherChange.changeOccupationNumber;
          delete otherChange.newOccupationNumber;
        }
        const shouldHaveNabyvatel = otherChange.changeOccupationType &&
          otherChange.newOccupationType &&
          PERMANENT_WITH_PURCHASE.includes(otherChange.newOccupationType.number);
        if (shouldHaveNabyvatel && otherChange.newNabyvatel) {
          otherChange.newNabyvatel = typeof otherChange.newNabyvatel === 'object'
            ? { nabyvatel: otherChange.newNabyvatel.id, typNabyvatele: otherChange.newNabyvatel.typNabyvatele, icoNabyvatele: otherChange.newNabyvatel.icoNabyvatele, acquirerId: otherChange.newNabyvatel.acquirerId }
            : { nabyvatel: otherChange.newNabyvatel };
        } else {
          delete otherChange.newNabyvatel;
        }
        item.finalSolutionOtherChange = otherChange;
      } else {
        item.finalSolutionOtherChange = null;
      }
      item.finalSolutionState = "PENDING";
      try {
        await this.restangular.one('occupations', item.id)
          .customPUT(item).toPromise();
        updatedCount++;
      } catch (error) {
        console.log(error);
        const reason = (error && error.data && error.data.message) || (error && error.message) || 'Neznámá chyba';
        failureMap[reason] = (failureMap[reason] || 0) + 1;
      }
    }
    const failedGroups = Object.keys(failureMap).map(reason => ({ reason, count: failureMap[reason] }));
    this.notifyParent(updatedCount, totalCount, failedGroups);
  }

  notifyParent(updatedCount: number, totalCount: number, failedGroups: Array<{ reason: string; count: number }>) {
    this.callbacks.get(Callbacks.DataValidityChanged)({
      isValid: () => false,
      data: {
        updatedCount,
        totalCount,
        failedGroups,
        occupationSolutionType: this.data.details.occupationSolutionType,
        finalSolutionReason: this.data.details.finalSolutionReason,
      },
    });
  }
}
